<template>
  <div>
    <PageAllow controller="StockRoadways" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="code"
                v-model="options.code"
                @text="code = $event"
                :label="$t('stockRoadway.Keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherStockArea
                v-model="stockAreaSelected"
                :stock-id="stock_id"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = {};
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("stockRoadway.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_roadways"
            :page.sync="paging.page"
            :options.sync="options"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 查看 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt</v-icon
                  >
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("stockRoadway.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("stockRoadway.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("stockRoadway.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('stockRoadway.ObjectName')"
      @confirm="
        deleteStockRoadway();
        deleteDialog = false;
      "
    />
    <!-- 操作跳转 -->
    <StockContainersDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getStockRoadwaysFromAPI()"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import StockRoadways from "@/api/stock_roadways";
import Stocks from "@/api/stocks";
import StockContainersDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";

const defaultOptions = {
  code: "",
  stock_area_ids: [],
};

export default {
  components: {
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    DialogDelete,
    StockContainersDetail,
    SearcherStockArea,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockRoadways"),
          disabled: true,
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    headers: () => [
      {
        text: i18n.t("stockRoadway.Fields.code"),
        align: "start",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("stockRoadway.Fields.stock_name"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("stockRoadway.Fields.area_name"),
        align: "start",
        sortable: false,
        value: "stock_area.area_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    stock_id: 0,
    stock: {},
    stock_roadways: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    code: "",
    currentItemMode: null,
    currentItem: null,
    deleteDialog: false,
    stockAreaSelected: null,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = Number(this.$route.query.stock_id);

      //获取仓库信息
      Stocks.fetchOne(this.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    }
  },

  methods: {
    getStockRoadwaysFromAPI() {
      StockRoadways.fetch(
        Object.assign({}, this.options, { stock_ids: this.stock_id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_roadways = response.data.stock_roadways;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    // 弹窗 确认删除
    deleteStockRoadway() {
      if (this.currentItem) {
        StockRoadways.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getStockRoadwaysFromAPI();
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.stock_id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockRoadwaysFromAPI();
      },
    },
    stockAreaSelected: {
      handler() {
        this.options.stock_area_ids = this.stockAreaSelected
          ? this.stockAreaSelected.id
          : "";
      },
    },
  },
};
</script>